import React from "react";
import { GROUP_TYPE } from "@home-health-notify/domain";
import { useTranslation } from "hhn-commons";
import {
  ButtonLabel,
  DeleteGroupStyle,
  DeleteIconButton,
  StyledIcon as DeleteIcon,
} from "./Settings.style";

type DeleteButtonType = {
  groupType: GROUP_TYPE;
  onDelete: () => void;
};
const DeleteButton = ({ groupType, onDelete }: DeleteButtonType) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });
  const isBroadcastGroup = groupType === GROUP_TYPE.BROADCAST;

  return (
    <DeleteGroupStyle>
      <DeleteIconButton data-testid="delete-group-btn" onClick={onDelete}>
        <DeleteIcon />
        <ButtonLabel>
          {tNs(isBroadcastGroup ? "deleteBroadcast" : "deleteGroup")}
        </ButtonLabel>
      </DeleteIconButton>
    </DeleteGroupStyle>
  );
};

export default DeleteButton;
